export default __webpack_public_path__ + "static/media/slide2.563023a8.png";